import { render } from "./RoundButton.vue?vue&type=template&id=5ff6e156&scoped=true"
import script from "./RoundButton.vue?vue&type=script&lang=ts"
export * from "./RoundButton.vue?vue&type=script&lang=ts"

import "./RoundButton.vue?vue&type=style&index=0&id=5ff6e156&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5ff6e156"

export default script